import React, { Fragment, useState } from "react";

import Modal from "../UI/Modal/Modal";
import { connect } from "react-redux";
import * as actionCreators from "../../Store/actions/index";
import classes from "./ContactNow.module.css"

const ContactNow = (props) => {
    const token = localStorage.getItem('idToken');
    const [inputVal, setInputVal] = useState('');
    const form = (
        <form className={classes.ContactFrom}
            onSubmit={event => {
                event.preventDefault()
                props.onCreateNewChat(token, inputVal, props.dealerId)
                props.onToggelContactNow()
            }}>
            <input
                placeholder='Start chating ...'
                type='text'
                value={inputVal}
                onChange={event => {
                    setInputVal(event.target.value)
                }} />
            <button>send</button>
        </form>
    );

    return (
        <Fragment>
            <Modal
                showModal={props.showContactNow}
                closeModal={props.onToggelContactNow}
            >
                <div className={classes.ContactNow}>
                    <p className={classes.DealerName}>{props.dealerName}</p>
                    <p className={classes.DealerPhone}>Phone : {props.dealerNumber}</p>
                </div>
                {props.user ? form : null}
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = state => {
    return {
        showContactNow: state.ContactNow.showContactNow,
        dealerId: state.ContactNow.dealerId,
        dealerName: state.ContactNow.dealerName,
        dealerNumber: state.ContactNow.dealerNumber,
        //auth
        user: state.Auth.user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onToggelContactNow: () => { dispatch(actionCreators.toggelContactShow()) },
        onCreateNewChat: (token, message, reciverId) => { dispatch(actionCreators.createNewChat(token, message, reciverId)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactNow);